<template>
  <div>
    <router-link id="nav-adel-bot" aria-label="Página siguiente" v-if="nextPant && (screenTrack[0] < screenTrack[1])" @click.native="guardarubicacion()" class="rout-bot bot-right hvr-grow" :to="linksPath+(screenTrack[0]+1)"></router-link>
  </div>
</template>

<script>
import ScormMix from '../../js/mixins/scormmixins'
export default {
  props: {
    linksPath: {
      type: String,
      required: true
    }
  },
  data() {
    return {};
  },
  computed: {
    nextPant() {
      return this.$store.state.nextPant;
    },
    screenTrack() {
      return this.$store.state.screens;
    }
  },
  mixins: [ScormMix]
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// NavAdel.vue?4c97f940